import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { StarRating } from "./StarRating";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export const ReviewDialog = ({ booking, onOpenChange, onSubmitted }) => {
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setLoading(true);
    try {
      await api.post("/reviews", { booking_id: booking.id, rating, comment });
      toast.success("Danke für deine Bewertung!");
      onSubmitted && onSubmitted();
      onOpenChange();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={!!booking} onOpenChange={(v) => !v && onOpenChange()}>
      <DialogContent className="sm:max-w-md" data-testid="review-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl">{booking?.service_title} bewerten</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <div className="text-sm font-semibold text-slate-700 mb-2">Deine Bewertung</div>
            <StarRating value={rating} onChange={setRating} starClass="w-8 h-8" />
          </div>
          <Textarea data-testid="review-comment" value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Wie war dein Erlebnis mit diesem Partner?" />
          <Button onClick={submit} disabled={loading} className="w-full bg-emerald-600 hover:bg-emerald-700" data-testid="review-submit">
            {loading ? "Senden…" : "Bewertung abgeben"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
